module.exports = __webpack_public_path__ + "img/user.d3758a57.png";